const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorklistIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.334 28H2.667A2.739 2.739 0 0 1 0 25.2V5.6a2.739 2.739 0 0 1 2.667-2.8H8.24a3.924 3.924 0 0 1 7.52 0h5.574A2.739 2.739 0 0 1 24 5.6v19.6a2.739 2.739 0 0 1-2.666 2.8zm-16-8.4v2.8h9.333v-2.8zm0-5.6v2.8h13.333V14zm0-5.6v2.8h13.333V8.4zM12 2.8a1.368 1.368 0 0 0-1.332 1.4 1.335 1.335 0 1 0 2.666 0A1.369 1.369 0 0 0 12 2.8z",
    style: {
      fill: "#002d72"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorklistIcon);
export default __webpack_public_path__ + "static/media/worklist-icon.51a8a33ba0056889e2dca8dcd4eab8ca.svg";
export { ForwardRef as ReactComponent };